import React, { useEffect, useState } from "react";
import { Card, CardContent, Container, TextField, Stack } from "@mui/material";
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import { LoadingButton } from '@mui/lab';
import { useDispatch, useSelector } from "react-redux";
import { GetCMSView, ResetUpdateCMSView, UpdateCMSView } from "src/redux/actions/CMSActions";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ReactQuill from 'react-quill';
import "react-quill/dist/quill.snow.css";
import { toast } from 'react-toastify';
import Page from '../../components/Page';
import Loader from "src/components/Loader";

import { EditorState, convertToRaw,ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

const CMSView = () => {
    let { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation()
    const cmslistdata = useSelector(state => state.cms.cms_view.data)
    const updateCmsSelector = useSelector(state => state.cms.cms_updated)
    const isLoading = useSelector(state => state.cms.loading)
    const [name, setName] = useState(cmslistdata !== undefined ? cmslistdata.data.title : location.state ? location.state.title : "");
    const [text, setText] = useState(cmslistdata && cmslistdata.data && cmslistdata.data.content)
    const [editorState,setEditorState]=useState("");

   

    console.log("editorState--->>",editorState)
    useEffect(() => {
        dispatch(GetCMSView({ "cms_id": id }))
    }, [dispatch])

    useEffect(() => {
        const html = cmslistdata && cmslistdata.data && cmslistdata.data.content?cmslistdata.data.content:"";
        
        if(html){    
        const contentBlock = htmlToDraft(html);
        if (contentBlock) {
            const contentStateText = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            const editorStateText = EditorState.createWithContent(contentStateText);
            setEditorState(editorStateText)
          }
        }
    }, [cmslistdata])

    const modules = {
        toolbar: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
            ['link', 'image'],
            ['clean']
        ]
    };

    useEffect(() => {
        if (Object.keys(updateCmsSelector).length > 0) {
            if (updateCmsSelector.data.status) {
                toast.success(updateCmsSelector.data.message, { theme: "colored" })
                navigate(`/dashboard/cms/others`)
                dispatch(ResetUpdateCMSView())
            }
            else {
                // toast.success(updateCmsSelector.data.message)
            }
        }
    }, [updateCmsSelector])

    const formats = ['header', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'image'];

    const handleQuillChange = (value) => {
        setText(value)
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        
        dispatch(
            UpdateCMSView({
                title: name,
                content: draftToHtml(convertToRaw(editorState.getCurrentContent())),
                slug: cmslistdata?.data?.slug,
                cms_id: id,
            }),
        );
    }


 const onEditorStateChange = (editorState) => {
        setEditorState(editorState);
         //console.log(draftToHtml(convertToRaw(editorState.getCurrentContent())));
       };

    return (
        <Page title="Content Mangement System">
            <Container maxWidth="lg">
                {isLoading ? <Loader /> : null}
                <HeaderBreadcrumbs
                    heading="Content Mangement System"
                    links={[
                        { name: "Dashboard", href: "/dashboard/app" },
                        { name: "CMS", href: "/dashboard/cms/others" },
                        { name: "View / Edit" },
                    ]}
                />

                <Card>
                    <CardContent>
                        <form autoComplete="off" onSubmit={handleSubmit}>
                            {
                                cmslistdata !== undefined ?
                                    <Stack container spacing={3}>
                                        <TextField
                                            defaultValue={cmslistdata.data?.title}
                                            variant="outlined"
                                            type="text"
                                            label="Title"
                                            onChange={(e) => setName(e.target.value)}
                                            fullWidth
                                        />

                                        {/* <ReactQuill
                                            className="cms-content-editor mb-1"
                                            name="text"
                                            modules={modules}
                                            formats={formats}
                                            value={text}
                                            onChange={handleQuillChange}
                                        /> */}
                                        <Editor
                                            currentState={editorState}
                                            editorState={editorState}
                                            wrapperClassName="home-wrapper"
                                            editorClassName="home-editor"
                                            toolbar={{
                                            fontFamily: {
                                                options: ['Arial', 'Georgia', 'Impact', 'Tahoma', 'Roboto', 'Times New Roman', 'Verdana'],
                                            }
                                            }}
                                            onEditorStateChange={onEditorStateChange}
                                            placeholder=""
                                            hashtag={{}}
                                        />
                                    </Stack>
                                    :
                                    null
                            }
                            <br />

                            <LoadingButton size="sm" type="submit" variant="contained" loading={isLoading}> Submit </LoadingButton>
                        </form>
                    </CardContent>
                </Card>
            </Container>
        </Page>
    );
};

export default CMSView;
